import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import { md5Cipher } from "../utils/MD5Cipher";

const UserContext = React.createContext(null);

export function UserProvider(props: any) {
  // 1. Inicializar el estado recuperando los datos del localStorage si existen
  const [user, setUser] = useState(() => {
    const savedUser = window.localStorage.getItem("userLogged");
    if (savedUser) {
      try {
        const parsed = JSON.parse(savedUser);
        return parsed.username || null;
      } catch (e) {
        return null;
      }
    }
    return null;
  });

  const [superMode, setSuperMode] = useState(() => {
    const savedUser = window.localStorage.getItem("userLogged");
    if (savedUser) {
      try {
        const parsed = JSON.parse(savedUser);
        return parsed.super_mode || false;
      } catch (e) {
        return false;
      }
    }
    return false;
  });

  useEffect(() => {
    if (user !== null) {
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/user/setUserLastConnection`,
          {
            username: user,
          },
        )
        .then(({ data }) => {})
        .catch(({ response }) => {});
    }
  }, [user]);

  interface bodyRequest {
    username: string;
    password: string;
  }

  const login = (body: bodyRequest, callback: any) => {
    body.password = md5Cipher(body.password);
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/user/login`,
        body,
      )
      .then(({ data }) => {
        window.localStorage.setItem("userLogged", JSON.stringify(data));
        setUser(data.username);
        setSuperMode(data.super_mode); // Actualiza el superMode correctamente
        callback(true);
      })
      .catch(({ response }) => {
        // Corregido el operador de asignación (=) por comparación (===)
        if (response && response.status === 400) {
          callback(response);
        } else {
          callback(response);
        }
      });
  };

  const logout = () => {
    window.localStorage.removeItem("userLogged");
    setUser(null);
    setSuperMode(false); // Limpiar también el superMode al salir
  };

  const setUserConnection = () => {
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/user/setConnection`,
        {
          user: user,
        },
      )
      .then(({ data }) => {})
      .catch(({ response }) => {});
  };

  const value = useMemo(() => {
    return {
      user,
      superMode,
      setSuperMode,
      login,
      setUser,
      logout,
      setUserConnection,
    };
  }, [user, superMode]);

  return <UserContext.Provider value={value} {...props} />;
}

export function useUser() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error("useUser should be inside UserContext provider");
  }
  return context;
}
